import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';
import { UpdateVehicleSparePartsService } from 'src/app/services/mobile/update-vehicle-spare-parts.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Component({
  selector: 'app-update-spare-parts',
  templateUrl: './update-spare-parts.component.html',
  styleUrls: ['./update-spare-parts.component.css']
})
export class UpdateSparePartsComponent implements OnInit{
  public vehicle_id: string = '';
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicle: any;
  spare_parts: any;
  searchText: string = '';
  selectedSpareParts: any[] = []; // Array to store selected spare parts
  selectedSparePartsIDs: any[] = []; // Array to store selected spare parts IDs
  @ViewChild('confirmAvailableSparePartsModal') modalElement!: ElementRef;

  constructor(
    private mobileVehiclesService: MobileVehiclesService,
    private updateVehicleSparePartsService: UpdateVehicleSparePartsService,
    private activatedRoute:ActivatedRoute,
    private toastr: ToastrService,
    private location: Location,
  ){

  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;
      this.getVehicleData(this.vehicle_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

   /**
   * Get vehicle details
   * @param vehicle_id
   */
   getVehicleData(vehicle_id: string): void{
    this.mobileVehiclesService.getVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            this.fetchSpareParts();
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  fetchSpareParts():void{
    this.updateVehicleSparePartsService.getVehicleSpareParts()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.spare_parts = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

   // Function to handle checkbox change event
  checkboxChange(event: any, part: any) {

    if (event.target.checked) {

      this.selectedSpareParts.push({
        part_id: part.id,
        name: part.name
      });

    } else {

      const index = this.selectedSpareParts.findIndex(
        item => item.part_id === part.id
      );

      if (index !== -1) {
        this.selectedSpareParts.splice(index, 1);
      }
    }
  }

  openModal(){
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeModal(){
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  confirmAvailableSpareParts(){
    if(this.selectedSpareParts.length===0){
      this.toastr.error("Please select available spare parts to proceed!", 'Error!');
    }else{
      this.openModal();

      //Clear previously selected spare parts IDs
      this.selectedSparePartsIDs.length = 0;

      this.selectedSpareParts.forEach(part => {
        this.selectedSparePartsIDs.push(
          part.part_id
        );
      });
    }
  }

  /**
   * Update spare parts
   */
  updateSpareParts(){
   if(this.selectedSparePartsIDs.length===0){

      this.isLoading=false;
      let errorMessage="Please select spare parts to proceed!";
      this.toastr.error(errorMessage, 'Error!');

    }else{
      this.updateVehicleSparePartsService.update(this.vehicle.data.chassis_no,this.selectedSparePartsIDs)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            //Clear selected spare parts arrays
            this.selectedSpareParts.length = 0;
            this.selectedSparePartsIDs.length = 0;

            this.isLoading=false;  //Dismiss spinner

            this.toastr.success(response.message, 'Success!');

            //Close modal
            this.closeModal();

            //Navigate back to the previous screen
            this. goBack();
          }else if(response.status==='error'){
            this.isLoading=false;
            this.toastr.error(response.message, 'Error!');
          }else{
            this.isLoading=false;
            this.toastr.error("Unable to update vehicle spare parts. Please try again!", 'Error!');
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.toastr.error("An error occurred, please try again! ", 'Error!');
        }
      });
    }
  }

  goBack(): void {
    this.location.back();
  }
}
